import type { App } from 'vue'
import { THEME_DARK, THEME_LIGHT, THEME_SYSTEM } from '@/constant/theme-key'
import store from '@/store'

/**
 * 监听系统主题变更
 */
let matchMedia: MediaQueryList
export function watchSystemThemeChange() {
  if (matchMedia)
    return
  matchMedia = window.matchMedia('(prefers-color-scheme: dark)')
  matchMedia.onchange = () => {
    changeTheme(THEME_SYSTEM)
  }
}

/**
 * 变更主题色
 * @param theme 主题
 */
function changeTheme(theme: string) {
  // html 的 class
  let themeClassName = ''

  switch (theme) {
    case THEME_LIGHT:
      themeClassName = 'light'
      break
    case THEME_DARK:
      themeClassName = 'dark'
      break
    case THEME_SYSTEM:
      watchSystemThemeChange()
      themeClassName = matchMedia!.matches ? 'dark' : 'light'
      break
  }

  // arco-vue 的换肤
  if (themeClassName === THEME_LIGHT) {
    document.body.removeAttribute('arco-theme')
  }
  else if (themeClassName === THEME_DARK) {
    document.body.setAttribute('arco-theme', 'dark')
  }

  // 修改 html 的class
  document.querySelector('html')!.className = themeClassName
}

/**
 * 初始化主题
 */
export default {
  install(_app: App<Element>) {
    const { themeType } = storeToRefs(store.themeStore)
    // 1. 当主题发生改变时，或者进入系统时，可进行 html class 的配置
    watch(() => themeType.value, changeTheme, {
    // 初始化执行一次
      immediate: true,
    })
  },
}
